const reportTypes = {
  CREATED_DURING: 'CREATED_DURING',
  PROVIDER: 'PROVIDER',
  CLINIC: 'CLINIC',
  LICENSE: 'LICENSE',
};

export default reportTypes;
